import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faComments, faTimes, faAngleDoubleRight, faAngleDoubleLeft, faSync } from "@fortawesome/free-solid-svg-icons";
/* empty css                */
import ChatBarContainer from "../ChatBarContainer.js";
import { CHAT_VARIANT } from "../constants/index.js";
library.add(faComments, faTimes, faAngleDoubleRight, faAngleDoubleLeft, faSync);
const ChatBotApp = ({
  parcelNumber,
  parcelCode,
  orderId,
  postCode,
  variant = CHAT_VARIANT.DEFAULT,
  ...props
}) => {
  return /* @__PURE__ */ jsx("div", { id: "chat-view-wrapper", className: "chat-core-screen", children: /* @__PURE__ */ jsx("div", { id: "chat-view", children: /* @__PURE__ */ jsx(
    ChatBarContainer,
    {
      parcelNumber,
      parcelCode,
      orderId,
      postCode,
      ...props
    }
  ) }) });
};
ChatBotApp.propTypes = {
  parcelNumber: PropTypes.string,
  parcelCode: PropTypes.string,
  orderId: PropTypes.string,
  postCode: PropTypes.string,
  variant: PropTypes.oneOf([CHAT_VARIANT.DEFAULT, CHAT_VARIANT.CHAT_BUTTON])
};
export {
  ChatBotApp as default
};
//# sourceMappingURL=ChatBotApp.js.map
